<template>
  <v-container id="user-profile-view" fluid tag="section">
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          label="Kode Vessel"
          outlined
          dense
          v-model="formData.kv"
          @keydown.enter="getBL"
          :disabled="loading"
          :loading="loading"
          autofocus
          hint="Muat data container per kapal (BL diisi setelah keberangkatan)."
          persistent-hint
          height="10"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="8">
        <v-text-field
          label="Vessel"
          outlined
          dense
          disabled
          v-model="formData.vessel"
          :loading="loading"
          height="10"
        ></v-text-field>
      </v-col>
      <v-col cols="12" v-if="formData.tgl_berangkat">
        <v-alert dense outlined type="info" class="mb-0">
          Tgl berangkat: <strong>{{ tglBerangkatLabel }}</strong>
        </v-alert>
      </v-col>
    </v-row>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading Data
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <v-alert v-else-if="!vesselLoaded" type="info" dense outlined>
      Masukkan kode vessel lalu tekan Enter untuk memuat daftar container.
    </v-alert>

    <v-simple-table v-else>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" width="36%">NoBL</th>
            <th class="text-left" width="18%">Cargo</th>
            <th class="text-left" width="16%">NoCont</th>
            <th class="text-left" width="20%">BL</th>
          </tr>
        </thead>
        <tbody>
          <Container
            v-for="container in containers"
            :key="container.id"
            :data="container"
            @fetch-bl="getBL()"
          />
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "InputNoBL",
  data() {
    return {
      openTTBModal: false,
      loading: false,
      vesselLoaded: false,
      loadedForKv: "",
      formData: {
        kv: "",
        vessel: "",
        tgl_berangkat: null
      },
      containers: []
    };
  },
  components: {
    Container: () => import("@/components/DataBL/InputNoBL.vue")
  },
  computed: {
    tglBerangkatLabel() {
      if (!this.formData.tgl_berangkat) return "";
      const d = new Date(this.formData.tgl_berangkat);
      if (Number.isNaN(d.getTime())) return this.formData.tgl_berangkat;
      return d.toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric"
      });
    }
  },
  watch: {
    "formData.kv"(val) {
      if (val) this.formData.kv = String(val).toUpperCase();
      const t = (this.formData.kv || "").trim();
      if (t !== this.loadedForKv) {
        this.vesselLoaded = false;
        this.containers = [];
        this.formData.vessel = "";
        this.formData.tgl_berangkat = null;
        this.loadedForKv = "";
      }
    }
  },
  methods: {
    async getBL() {
      const kv = (this.formData.kv || "").trim();
      if (!kv) {
        alert("Isi kode vessel terlebih dahulu.");
        return;
      }

      this.loading = true;

      await axios
        .get(`data-bl/${encodeURIComponent(kv)}`)
        .then(res => {
          this.loading = false;
          this.loadedForKv = kv;
          this.vesselLoaded = true;
          this.formData.vessel = res.data.vessel || "";
          this.formData.tgl_berangkat = res.data.tgl_berangkat || null;
          this.containers = res.data.container || [];
        })
        .catch(err => {
          this.loading = false;
          this.vesselLoaded = false;
          this.loadedForKv = "";
          this.containers = [];
          this.formData.vessel = "";
          this.formData.tgl_berangkat = null;
          const msg =
            (err.response && err.response.data && err.response.data.message) ||
            "Gagal memuat data.";
          alert(msg);
        });
    }
  }
};
</script>
